export const getCountriesSelector = store => {
    return store.getIn(["countries", "countries"])
}